var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "channel-card",
      class: { "channel-card-sm": _vm.windowIsSmall },
      style: { borderTopColor: _vm.$themePalette.grey.v_200 },
    },
    [
      _c("ChannelDetails", {
        attrs: { channel: _vm.channel },
        scopedSlots: _vm._u([
          {
            key: "beforethumbnail",
            fn: function () {
              return [
                _c("KCheckbox", {
                  staticClass: "checkbox",
                  attrs: {
                    label: _vm.channel.name,
                    showLabel: false,
                    checked: _vm.$attrs.checked,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("checkboxchange", {
                        channel: _vm.channel,
                        isSelected: $event,
                      })
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "abovedescription",
            fn: function () {
              return [
                _vm.resourcesOnDevice
                  ? _c("p", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tr("resourcesOnDevice")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "col-3" }, [
        _vm.selectedMessage
          ? _c("p", { staticClass: "selected" }, [
              _vm._v("\n      " + _vm._s(_vm.selectedMessage) + "\n    "),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }